 
import {useQuery, gql} from "@apollo/client";
var SALESCONTACT = gql`
query SalesFastContact {
  salesFastContact {
    displayText
    bag {
      contentItems {
        ... on SalesFastContactEntry {
          displayText
          salesInfo {
            html
          }
        }
      }
    }
  }
}
`;
export const useSalesContactData = () => {
  const {error, data, loading} = useQuery(SALESCONTACT);
  return {
    error,
    data,
    loading
  }
}